/* Panier Petite Duchesse (tiroir et page panier) :
   - livraison estimée « Livrée entre le [debut] et le [fin] » (même calcul que la fiche produit : jours ouvrés,
     sans week-ends ni fériés français, heure de Paris, après l'heure limite on part du jour ouvré suivant) ;
   - nombre d'articles de l'en-tête du tiroir (« 2 articles ») ;
   - « Complétez son look » : couleur la plus proche de la robe pré-sélectionnée (pd-color.js), ajout au panier
     sans fermer le tiroir ; le tiroir est réaffiché et l'article ajouté disparaît du carrousel.
   Le thème réaffiche le tiroir (innerHTML de #minicart-form) à chaque changement : tout est relancé à ce moment. */
(function () {
  function renderDelivery(el) {
    if (el.dataset.pdDeliveryReady || !window.PdDelivery) return;
    el.dataset.pdDeliveryReady = 'true';
    // Calcul partagé avec la fiche produit et le Dressing (pd-delivery.js)
    window.PdDelivery.render(el, el.dataset.template, { min: el.dataset.min, max: el.dataset.max });
    el.hidden = false;
    const box = el.closest('[data-pd-delivery-box]');
    if (box) box.hidden = false;
  }

  function syncCount() {
    const source = document.querySelector('#minicart-form [data-pd-cart-count-src]');
    if (!source) return;
    const count = Number(source.dataset.pdCartCountSrc) || 0;
    document.querySelectorAll('[data-pd-cart-count]').forEach((el) => {
      const text = count ? `${count} ${count > 1 ? el.dataset.other : el.dataset.one}` : '';
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function updateLookCard(card) {
    const checked = card.querySelector('.pd-cart-look__radio:checked');
    if (!checked) return;
    const value = card.querySelector('[data-pd-cart-look-value]');
    const price = card.querySelector('[data-pd-cart-look-price]');
    if (value) value.textContent = checked.dataset.name;
    if (price && checked.dataset.price) price.textContent = checked.dataset.price;
  }

  function initLook(look) {
    if (look.dataset.pdCartLookReady) return;
    look.dataset.pdCartLookReady = 'true';
    const color = look.dataset.colorName ? { name: look.dataset.colorName, hex: look.dataset.colorHex } : null;
    look.querySelectorAll('[data-pd-cart-look-card]').forEach((card) => {
      const radios = [...card.querySelectorAll('.pd-cart-look__radio:not(:disabled)')];
      const pick = color && window.PdColor && window.PdColor.closest(radios, color);
      if (pick) pick.checked = true;
      updateLookCard(card);
    });
  }

  const renderAll = () => {
    document.querySelectorAll('[data-pd-delivery]').forEach(renderDelivery);
    document.querySelectorAll('[data-pd-cart-look]').forEach(initLook);
    syncCount();
  };

  async function addLook(button) {
    const card = button.closest('[data-pd-cart-look-card]');
    const look = button.closest('[data-pd-cart-look]');
    const checked = card.querySelector('.pd-cart-look__radio:checked');
    const variantId = checked ? checked.value : button.dataset.variantId;
    if (!variantId || button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: 'minicart-form',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || '');

      const live = document.querySelector('[data-pd-cart-live]');
      if (live) live.textContent = `${look.dataset.addedLabel} : ${button.dataset.title}${checked ? ` (${checked.dataset.name})` : ''}`;

      // Tiroir réaffiché sur place (il reste ouvert) : l'article apparaît dans la liste et sort du carrousel
      const html = data.sections && data.sections['minicart-form'];
      const target = document.getElementById('minicart-form');
      const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
      if (target && fresh) target.innerHTML = fresh.innerHTML;
      renderAll();
      const next =
        document.querySelector('#minicart-form [data-pd-cart-look-add]') ||
        document.querySelector('#minicart-form .pd-cart-summary__pay');
      if (next) next.focus({ preventScroll: true });

      const cart = await (await fetch(`${root}cart.js`)).json();
      document.querySelectorAll('.cart-count').forEach((el) => {
        el.innerHTML = el.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count > 100 ? '~' : cart.item_count;
      });
      const total = document.querySelector('header-total-price');
      if (total && typeof total.updateTotal === 'function') total.updateTotal(cart);
    } catch (error) {
      const errorBox = card.querySelector('[data-pd-cart-look-error]');
      if (errorBox) {
        errorBox.textContent = error.message || look.dataset.errorLabel;
        errorBox.hidden = false;
        clearTimeout(errorBox.pdTimer);
        errorBox.pdTimer = setTimeout(() => {
          errorBox.hidden = true;
        }, 5000);
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pd-cart-look-add]');
    if (button) addLook(button);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.classList.contains('pd-cart-look__radio')) return;
    const card = event.target.closest('[data-pd-cart-look-card]');
    if (card) updateLookCard(card);
  });

  renderAll();
  new MutationObserver(renderAll).observe(document.body, { childList: true, subtree: true });
})();
